import { initializeApp, getApps, getApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL || '',
};

let dbInstance = null;

export function getFirebaseDatabase() {
  if (dbInstance) return dbInstance;

  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  dbInstance = getDatabase(app);
  return dbInstance;
}
